import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import { toCamel } from 'snake-camel';


type Material = {
    id: string;
    name: string;
    memo: string;
    type: "DEPRECIATION_TIMES" | "DEPRECIATION_USES" | "EXPENDABLE";
    isHidden: boolean;
    isEditable: boolean;
}

type MaterialsGet = {
    materials: Material[];
}

export type Item = {
    id: string;
    name: string;
    memo: string;
    isActive: boolean;
}

@Component({
    components: {
        Modal,
        Thumbnail
    }
})
export default class MaterialsModal extends Vue {

    @Prop()
    isShowMaterialsModal!: boolean


    private list: any | null = null
    private title = '資材'
    private tabTitle = '資材情報'
    private baseUrl = '/materials';
    private clientBaseUrl = '/master/materials'
    private materials: Material[] = []
    private withHidden = false
    private isLoading = false
    private headerTitle!: string
    private selectedMaterial!: Material
    private materialId = ""
    private materialName = ""
    private materialMemo = ""
    private materialType: "DEPRECIATION_TIMES" | "DEPRECIATION_USES" | "EXPENDABLE" = "EXPENDABLE"
    private isHidden = false
    private isEditable = true
    private isSpinnerLoading = false
    private searchText = ''
    private checked = false
    private selectedItem = "";
    private alteredMaterials = false;
    private hiddenSwitchbtn = false


    @Watch('isShowMaterialsModal')
    onIsShowMaterialsModalChanged(newVal: boolean) {
        if (newVal) {
            this.getMaterials(false)
        }
    }

    @Watch('isShowMaterialsModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }


    private getMaterials(withHidden: boolean) {
        this.list = null
        this.isLoading = true
        this.isSpinnerLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?type=ALL&with_hidden=${withHidden}`).then(ret => {
            this.materials = (toCamel(ret) as MaterialsGet).materials as Material[]
            this.list = this.materials;
            if (this.selectedItem) {
                this.isActive(this.selectedItem);
            }
            this.doSearch();
        })
        .finally(() => {
            this.isLoading = false
            this.isSpinnerLoading = false
        })
    }

    private createMaterials(flag:boolean) {
        this.inputChangedcheck()
        if (this.alteredMaterials == false) {
            this.headerTitle = "新規資材"
            this.materialId = "create"
            this.materialName = ""
            this.materialMemo = ""
            this.materialType = "EXPENDABLE"
            this.selectedItem = ""
            this.isHidden = false
            this.isEditable = true
            this.isActive(this.selectedItem);
             if(flag){
                this.openSideBar()
            }
        }
    }

    @Watch('checked')
    private toggleHiddenItems(value: boolean) {
        this.withHidden = value;
        this.getMaterials(this.withHidden)
    }

    @Watch('searchText')
    private doSearch() {
        const keyword = this.searchText?.trim() ?? '';

        if (!keyword) {
            this.materials = this.list;
            return;
        }
        this.materials = this.list?.filter((item: Item) => item.name.indexOf(this.searchText) > -1)
    }

    private setMaterials(materialId: string) {
        this.headerTitle = "資材情報"
        this.inputChangedcheck();
        if (this.alteredMaterials == false) {
            if (document.body.classList.contains('newsSide')) {
                document.body.classList.remove('newsSide')
            }
            this.selectedItem = materialId;
            this.$apiClient.doRequest("get", `${this.baseUrl}/${materialId}`).then((ret) => {
                const item = this.selectedMaterial = toCamel(ret) as Material
                this.materialId = item.id
                this.materialName = item.name
                this.materialMemo = item.memo
                this.materialType = item.type
                this.isHidden = item.isHidden
                this.isEditable = item.isEditable
            })
            this.isActive(materialId);
        }
    }
    setItem(id: string){
        if (id === this.selectedItem) {
            return;
        }
        this.setMaterials(id);
    }

    private switchDisplay() {
        if (!window.confirm(`${this.selectedMaterial.name}を${this.isHidden ? '表示状態に戻します' : '非表示にします'}。よろしいですか？`)) {
            return
        }
        this.isLoading = true
        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.materialId}/display?is_hidden=${!this.isHidden}`).then(() => {
            this.isHidden = !this.isHidden;
            this.getMaterials(this.withHidden)
            this.$toasted.success(this.isHidden ? '非表示に変更しました。' : '表示に変更しました。')
        })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
    }

    private cancelEdit() {
        if (this.alteredMaterials) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.alteredMaterials = false;
        if (this.materialId !== 'create') {
            this.setMaterials(this.materialId)
        } else {
            this.createMaterials(false)
        }
    }

    private submit() {
        const errmsg: string[] = []
        // 名前の入力
        if (!this.materialName.trim()) {
            errmsg.push("資材名を入力してください")
        }
        // 名前の長さ
        if (this.materialName.length > 100) {
            errmsg.push(`資材名は100文字以内で入力してください（現在は${this.materialName.length}文字）`)
        }
        // メモ
        if (this.materialMemo && this.materialMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.materialMemo.length}文字）`)
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        this.isLoading = true
        const params = {
            name: this.materialName,
            memo: this.materialMemo,
            type: this.materialType
        }

        if (this.materialId === "create") {
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((ret) => {
                this.getMaterials(this.withHidden)
                this.selectedItem = ret?.id
                this.isActive(ret.id)
                this.setMaterials(ret.id)
                this.$toasted.success('保存しました。')
            })
                .catch(() => {
                    this.$toasted.error('保存に失敗しました。')
                })
                .finally(() => {
                    this.isLoading = false
                })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if (!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.materialId}`, params).then(() => {
                this.getMaterials(this.withHidden)
                this.$toasted.success('変更を保存しました。')
            })
                .catch(() => {
                    this.$toasted.error('変更に失敗しました。')
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
        this.alteredMaterials = false;
    }
    @Emit('inputChanged')
    private inputChanged() {
        if (this.alteredMaterials == false) {
            this.alteredMaterials = true
        }
    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if (document.body.classList.contains('newsSide')) {
            document.body.classList.remove('newsSide')
        } else {
            document.body.classList.add('newsSide')
        }
    }

    closeModal() {
        if (this.alteredMaterials && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
        }
        this.$emit('update:isShowMaterialsModal', false);
        this.materials = [];
        this.searchText = '';
        this.checked = false;
        this.withHidden = false;
        this.materialId = '';
        this.selectedItem = '';
        this.alteredMaterials = false;
    }

    inputChangedcheck() {
        if (this.alteredMaterials == true) {
            const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if (confirm) {
                this.alteredMaterials = false
            }
        }
    }


    private isActive(id: string) {
        this.materials?.forEach((item: any) => {
            item.isActive = item.id === id;
        });
    }

}